import React, { useMemo } from 'react';
import ApiScaleGrid from '../Escala Medica/ApiScaleGrid';

const getText = (value) => {
	if (value == null) return '';
	if (typeof value === 'object') {
		return getText(value.nome || value.nome_exibicao || value.descricao || value.label);
	}
	return String(value).trim();
};

const getCategoryLabel = (item = {}) =>
	getText(
		item.categoria ||
		item.nome_categoria ||
		item.categoria_nome ||
		item.resumo?.categoria ||
		item.edicao?.categoria,
	);

const adaptItem = (item = {}) => {
	const categoria = getCategoryLabel(item);
	if (!categoria) return item;

	return {
		...item,
		especialidade: item.especialidade || categoria,
		nome_especialidade: item.nome_especialidade || categoria,
		resumo: {
			...(item.resumo || {}),
			especialidade: item.resumo?.especialidade || categoria,
		},
	};
};

const adaptPayload = (payload = {}) => {
	const grade = payload.grade || payload.visualizacao || {};
	return {
		...payload,
		itens: Array.isArray(payload.itens) ? payload.itens.map(adaptItem) : payload.itens,
		grade: {
			...grade,
			setores: (grade.setores || []).map((setor) => ({
				...setor,
				linhas: (setor.linhas || []).map((linha) => ({
					...linha,
					celulas: (linha.celulas || []).map((celula) => ({
						...celula,
						cards: Array.isArray(celula.cards) ? celula.cards.map(adaptItem) : celula.cards,
					})),
				})),
			})),
		},
	};
};

function ApiScaleGridMultiprofissional({ payload, onEditItem, canManageItems = false }) {
	const adaptedPayload = useMemo(() => adaptPayload(payload), [payload]);

	return (
		<ApiScaleGrid
			payload={adaptedPayload}
			onEditItem={onEditItem}
			canManageItems={canManageItems}
			canModifyItems={false}
			preservarAlturaNomeSetor
			agruparPorEspecialidade
			rotuloAgrupamento='Categoria'
			seguirTituloAgrupamentoNoScroll
			abreviarTurnoCompacto
			compactarNomeProfissionalNoCard
			regime={adaptedPayload.contexto?.regime || ''}
		/>
	);
}

export default ApiScaleGridMultiprofissional;
